export const REAL_EVENT_PURCHASE = '@REAL_EVENT/REAL_EVENT_PURCHASE';
export const PURCHASE_WITH_CREDIT_CARD = '@REAL_EVENT/PURCHASE_WITH_CREDIT_CARD';
export const PURCHASE_WITH_KOBINI = '@REAL_EVENT/PURCHASE_WITH_KOBINI';
export const SET_CARD_INFO = '@REAL_EVENT/SET_CARD_INFO';
export const CLEAR_CARD_INFO = '@REAL_EVENT/CLEAR_CARD_INFO';
